module.exports = __webpack_public_path__ + "static/img/scene7.280cd9c7.jpg";